<div class="eva-menu" [class.eva-menu--open]="isOpen" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <!-- Trigger -->
  <div class="eva-menu__trigger" (click)="toggle(); $event.stopPropagation()">
    <ng-container *ngTemplateOutlet="menuTrigger"></ng-container>
  </div>

  <!-- Dropdown (position fixed par défaut, pas de CDK Overlay) -->
  @if (isOpen) {
    <div
      #dropdownEl
      class="eva-menu__dropdown"
      role="menu"
      [class.eva-menu__dropdown--fixed]="appendTo === 'body' || anchor"
      [class.eva-menu__dropdown--bottom-left]="position === 'bottom-left'"
      [class.eva-menu__dropdown--bottom-right]="position === 'bottom-right'"
      [class.eva-menu__dropdown--top-left]="position === 'top-left'"
      [class.eva-menu__dropdown--top-right]="position === 'top-right'"
      [@dropdownAnimation]
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
    >
      <ng-container *ngFor="let item of items">
        <!-- Section header -->
        <div *ngIf="item.sectionHeader" class="eva-menu__section-header">
          {{ item.label }}
        </div>

        <!-- Separator -->
        <div *ngIf="item.separator && !item.sectionHeader" class="eva-menu__separator" role="separator"></div>

        <!-- Menu item -->
        <button
          *ngIf="!item.separator && !item.sectionHeader"
          type="button"
          role="menuitem"
          class="eva-menu__item"
          [class.eva-menu__item--danger]="item.severity === 'danger'"
          [class.eva-menu__item--disabled]="item.disabled"
          [class.eva-menu__item--with-description]="!!item.description"
          [disabled]="item.disabled"
          (pointerdown)="onItemPointerDown(item, $event)"
          (keydown)="onItemKeydown(item, $event)"
        >
          @if (item.icon && isClassIcon(item.icon)) {
            <i [class]="item.icon" class="eva-menu__item-icon"></i>
          } @else if (item.icon) {
            <ng-icon [name]="item.icon" class="eva-menu__item-icon"></ng-icon>
          }
          <div class="eva-menu__item-content">
            <span class="eva-menu__item-label">{{ item.label }}</span>
            <span *ngIf="item.description" class="eva-menu__item-description">{{ item.description }}</span>
          </div>
        </button>
      </ng-container>
    </div>
  }
</div>
